import React from 'react';
import styles from './Find.module.css';
import Card from './Card';
import Micra from '../../images/cars/micra.png';
import Yaris from '../../images/cars/yaris.png';
import Logan from '../../images/cars/logan.png';
import Corolla from '../../images/cars/corolla.png';
import Sandero from '../../images/cars/sandero.png';
import Duster from '../../images/cars/daster.jpg';
import Tucson from '../../images/cars/tucson.avif';
import Prado from '../../images/cars/prado.png';
import Fortuner from '../../images/cars/fortuner.png';
import Rav_fore from '../../images/cars/Rav4_2021.jpg';
import Hyundai_Creta from '../../images/cars/creta.jpg'



import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';


const Find = () => {
  return (
    <div className={styles.find}>
      <div className={styles.heading}>
        <h1>Find Your Car</h1>
        {/* <div className={styles.text_bg}>
          <p>
            <span>Rent a Car in Georgia</span>
          </p>
        </div> */}
      </div>
      <div className={styles.slider_container}>
        <Swiper
         
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={10}
          slidesPerView={3}
          navigation
          breakpoints={{
            
            340: {
              width: 200,
              slidesPerView: 1,
            },
            
            768: {
              width: 768,
              slidesPerView: 2,
            },
          
            1040: {
              width: 1040,
              slidesPerView: 3,
            },
          }}
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
          onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={() => console.log('slide change')}
        >
          <SwiperSlide>
            <Card
              image={Prado}
              make='Toyota Prado'
              link='/Toyota_Prado'
            />
          </SwiperSlide>

          <SwiperSlide>
            <Card
              image={Fortuner}
              make='Toyota Fortuner'
              link='/Toyota_Fortuner'
            />
          </SwiperSlide>

          <SwiperSlide>
            <Card
              image={Micra}
              make='Nissan Micra'
              link = '/nissan_micra'
            />
          </SwiperSlide>
          
          <SwiperSlide>
            <Card
              image={Duster}
              make='Renault Duster'
              link='/Renault_daster'
            />
          </SwiperSlide>
          <SwiperSlide>
            <Card
              image={Tucson}
              make='Hyundai Tucson'
              link= '/Hyundai_Tucson'
            />
          </SwiperSlide>

          
          <SwiperSlide>
            <Card
              image={Yaris}
              make='Toyota Yaris'
              link = '/toyoya_yarus'
            />
          </SwiperSlide>
          

          <SwiperSlide>
            <Card
              image={Corolla}
              make='Toyota Corolla'
              link='/Toyota_Corolla'
            />
          </SwiperSlide>
          <SwiperSlide>
            <Card
              image={Logan}
              make='Renault Logan'
              link='/Renault_Logan'
            />
          </SwiperSlide>
          
          
          <SwiperSlide>
            <Card
              image={Sandero}
              make='Renault Sandero'
              link='/Renault_Sandero'
            />
          </SwiperSlide>

          <SwiperSlide>
            <Card
              image={Rav_fore}
              make='Toyota Rav4'
              link='/Rav_fore'
            />
          </SwiperSlide>
          
          <SwiperSlide>
            <Card
              image={Hyundai_Creta}
              make='Hyundai Creta'
              link='/Hyundai_Creta'
            />
          </SwiperSlide>
          
        </Swiper>
      </div>
    </div>
  );
};

export default Find;